import { render } from "./AnnouncementsView.vue?vue&type=template&id=8f20c8ca"
import script from "./AnnouncementsView.vue?vue&type=script&lang=js"
export * from "./AnnouncementsView.vue?vue&type=script&lang=js"

import exportComponent from "/root/hr-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__